import axios from '../assets/axios'
import { setKey, getKey, isEmptyObject } from '../assets/utils'

export default {
  namespaced: true,

  state: {
    OCRInfo: {},
    baseInfo: {}
  },

  mutations: {
    IDOCR (state, data) {
      state.OCRInfo = data
    },

    // 保存基本信息
    cacheBaseInfo (state, params) {
      setKey('baseInfo', params)
      state.baseInfo = params
    }
  },

  actions: {
    // 身份证OCR识别
    async TXOCRX ({ commit }, params) {
      const response = await axios.post('/idcardocr/tencent/v1/idcardocrapp', params)
      if (response.data.success) {
        commit('IDOCR', response.data.data)
      }
      return response.data
    },

    // 预授信申请
    async preCreditApplyX ({ commit }, params) {
      const response = await axios.post('/credit/v1/pre-check', params)
      return response.data
    },

    // 授信申请
    async creditApplyX ({ commit }, params = { loanPlatform: 'TMD' }) {
      const response = await axios.post('/credit/v1/apply', params)
      return response.data
    },

    // 保存用户基础信息
    async saveBaseInfoX ({ commit }, params) {
      const response = await axios.post('/user/v1/base-info', params)
      return response.data
    },
    // 保存小花用户基础信息
    async saveSmallFlowerBaseInfoX ({ commit }, params) {
      const response = await axios.post('/user/v2/base-info', params)
      return response.data
    },
    // 获取用户基本信息
    async getBaseInfoX ({ commit, state }) {
      const baseInfo = getKey('baseInfo')
      if (!isEmptyObject(state.baseInfo)) {
        await Promise.resolve(state.baseInfo)
        return state.baseInfo
      } else if (!isEmptyObject(baseInfo)) {
        commit('cacheBaseInfo', baseInfo)
        return baseInfo
      }
      return baseInfo
    },

    async getCreditResultX ({ commit }, params) {
      const response = await axios.post('/credit/v1/result', params)
      return response.data
    },

    // 腾讯云 - 获取token
    getTencentTokenX: ({ commit, state }, params) => {
      return axios({
        url: '/liveness/tencent/v2/initConfig',
        method: 'POST',
        data: params
      }).then(response => response)
    },


    // 腾讯云 - 验证活体认证结果
    verifyTencetLivenessResultX: ({ commit, state }, params) => {
      return axios({
        url: '/liveness/tencent/v1/resultPut',
        method: 'POST',
        data: params
      }).then(response => response.data)
    },
    // 三要素验证
    async verifyOcrX ({ commit, state }, params) {
      const response = await axios.post('/idcardocr/tencent/v1/ocr-verify', params)
      return response.data
    },
    // 上传文件到OSS
    async uploadOSS ({ commit, state }, params) {
      const response = await axios.post('/user/v1/upload-file', params)
      return response.data
    },
    // 获取补充资料填写的灵活配置
    async getQuickConfigX ({ commit }, params) {
      const response = await axios.post(`/sys/v1/getQuickConfig`, params)
      return response.data
    },
    // 保存补充资料填写
    async saveQuickConfigX ({ commit }, params) {
      const response = await axios.post('/sys/v1/saveQuickConfig', params)
      return response.data
    },
    // 查询授信排队中信息
    async queryQueueX ({ commit }, params) {
      const response = await axios.post('/credit/v1/queueQuery', params)
      return response.data
    },
    // 使用授信重审卡
    async reAuditX ({ commit }, params) {
      const response = await axios.post('/credit/v1/reAudit', params)
      return response.data
    },
    // 查询供应商
    async goodsInfoX ({ commit }, params) {
      const response = await axios.post('/membership/v1/goodsInfo', params)
      return response.data
    },
    // 预授信拒绝产品推荐 返回null不展示该页面
    async preCreditPopup ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/pre-credit-popup', params)
      return response.data
    },
    async getApiListPageShowType ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/grant-result-mask', params)
      return response.data
    },
    async xmVipQualifications ({ commit }, params) {
      const response = await axios.post('/loan-market/v1/xmvip-qualifications', params)
      return response.data
    },
    // 补充资料
    async fillProcessX ({ commit }, params) {
      const response = await axios.post('/credit/v1/fillProcess', params)
      return response.data
    },
    // 补充资料提交
    async saveFillInfoX ({ commit }, params) {
      const response = await axios.post('/credit/v1/saveFillInfo', params)
      return response.data
    },
    async getResultPageInfo ({ commit }, params) {
      const response = await axios.post('/result/v1/page', params)
      return response.data
    },
    async onlyPreApply ({ commit }, params) {
      const response = await axios.post('/credit/v1/onlyPreApply', params)
      return response.data
    },
    async upGuideInfo ({ commit }, params) {
      const response = await axios.post('/up/v1/guide', params)
      return response.data
    },
    async channelConfigX ({ commit }, params) {
      const response = await axios.post('/channel/v1/config', params)
      return response.data
    },
    // 旷世活体
    async megviiFaceX ({ commit }, params) {
      const response = await axios.post('/liveness/megvii/token', params)
      return response.data
    },
    async megviiFaceResultX ({ commit }, params) {
      const response = await axios.post('/liveness/megvii/state', params)
      return response.data
    },
    async appletTagX ({ commit }, params) {
      const response = await axios.post('/index/v1/appletTag', params)
      return response.data
    }
  }
}
